module.exports = __webpack_public_path__ + "img/edge.af3d3bae.jpg";